import { withBreakpointObserver } from '@studiometa/js-toolkit';
import {
  Slider as SliderCore,
  SliderDrag,
  SliderProgress,
  SliderItem,
  SliderDots,
  SliderBtn,
} from '@studiometa/ui';

/**
 * @typedef {import('@studiometa/ui').SliderProps} SliderCoreProps
 * @typedef {import('@studiometa/js-toolkit').WithBreakpointObserverProps} WithBreakpointObserverProps
 * @typedef {WithBreakpointObserverProps & SliderCoreProps & {
 *   $children: {
 *     SliderDrag: SliderDrag[],
 *     SliderItem: SliderItem[],
 *     SliderProgress: SliderProgress[],
 *     SliderDots: SliderDots[],
 *     SliderBtn: SliderBtn[],
 *   }
 * }} SliderProps
 */

/**
 * Slider.
 * @augments {SliderCore<SliderProps>}
 */
export default class Slider extends withBreakpointObserver(SliderCore) {
  interval = null;

  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Slider',
    components: {
      SliderDrag,
      SliderItem,
      SliderProgress,
      SliderDots,
      SliderBtn,
    },
    options: {
      autoPlay: Boolean,
      ...SliderCore.config.options,
    },
  };

  /**
   *
   */
  mounted() {
    if (this.$options.autoPlay) {
      this.launchAutoPlay();
    }
    super.mounted();
  }

  /**
   *
   */
  launchAutoPlay() {
    this.interval = setInterval(() => {
      this.changeSlide();
    }, 7000);
  }

  /**
   *
   */
  changeSlide() {
    const nextIndex = this.currentIndex === this.indexMax ? 0 : this.currentIndex + 1;
    this.goTo(nextIndex);
  }

  /**
   *
   */
  onMouseenter() {
    console.log('mouseenter');
    clearInterval(this.interval);
  }

  /**
   *
   */
  onMouseleave() {
    console.log('mouseleave');
    this.launchAutoPlay();
  }
}
